import React from 'react'

import { BasicModal } from '@/components/layout/modals/BasicModal'
import { Button } from '@/components/buttons/Button'
import { ModalActions } from '@/components/modals/ModalActions'
import { Card } from '@/components/cards/Card'

export const DeleteOrganizationButton = ({ deleteOrganization }) => {
  return (
    <Card>
      <h3>Delete Organization</h3>
      <BasicModal
        trigger={(handleOpen) => (
          <Button critical onClick={handleOpen} data-testid="delete-organization-button-default">
            Delete
          </Button>
        )}
        title="Delete Organization"
        size="tiny"
      >
        {(handleClose) => (
          <ModalActions onClose={handleClose} onSubmit={deleteOrganization} isDelete>
            <p>
              Are you sure you want to delete this organization? You will lose all users. This
              cannot be undone.
            </p>
          </ModalActions>
        )}
      </BasicModal>
    </Card>
  )
}
